import { Box } from "@mui/material";
import LanguageContext from "components/LanguageContext";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import t from "utils/locales/translation.json";

const SelectTagsContent = (props) => {
  const { allTags = [], selectedTags = [], handleSelectTagsForm = null, scrollable = false } = props;

  const { language } = useContext(LanguageContext);

  const handleSelectTags = (tag) => {
    if (selectedTags.includes(tag)) {
      handleSelectTagsForm(selectedTags.filter((st) => st !== tag));
    } else {
      handleSelectTagsForm([...selectedTags, tag]);
    }
  };

  const handleSelectAllTags = () => {
    if (selectedTags.length === 0) {
      handleSelectTagsForm(allTags);
    } else {
      handleSelectTagsForm([]);
    }
  };

  return (
    <>
      <Box
        component="button"
        type="button"
        className={`fr-btn fr-icon-${
          selectedTags.length === 0 ? "check" : "close-circle"
        }-line fr-btn--icon-left fr-btn--tertiary fr-mt-1w fr-my-2w`}
        sx={{ justifyContent: "center", width: "100%" }}
        onClick={handleSelectAllTags}
      >
        {selectedTags.length === 0 ? t[language].all_news.select_all : t[language].all_news.deselect_all}
      </Box>
      <Box sx={scrollable ? { maxHeight: "400px", overflowX: "auto" } : {}}>
        {allTags?.map((tag) => (
          <div className="fr-fieldset__element" key={tag}>
            <div className="fr-checkbox-group fr-checkbox-group--sm">
              <input
                name={tag}
                id={tag}
                type="checkbox"
                aria-describedby={tag}
                checked={selectedTags.includes(tag)}
                data-fr-js-checkbox-input="true"
                onChange={() => handleSelectTags(tag)}
              />
              <label className="fr-label" htmlFor={tag}>
                {tag.charAt(0).toUpperCase() + tag.slice(1)}
              </label>
            </div>
          </div>
        ))}
      </Box>
    </>
  );
};

SelectTagsContent.propTypes = {
  allTags: PropTypes.arrayOf(PropTypes.string),
  selectedTags: PropTypes.arrayOf(PropTypes.string),
  handleSelectTagsForm: PropTypes.func,
  scrollable: PropTypes.bool,
};

export default SelectTagsContent;
